import { useEffect, useState } from "react";

export default function ScrollButton({ delayInMs, scrollStepInPx }) {
  const [intervalId, setIntervalId] = useState(0);
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', updateHidden);

    return () => {
      window.removeEventListener('scroll', updateHidden);
    };
  }, []);

  const updateHidden = () => {
    setIsHidden(window.innerHeight - 100 > window.pageYOffset);
  }
  
  const scrollStep = () => {
    if (window.pageYOffset === 0) {
        clearInterval(intervalId);
    }
    window.scroll(0, window.pageYOffset - scrollStepInPx);
  }

  const scrollToTop = () => {
    let intervalId = setInterval(scrollStep, delayInMs);
    setIntervalId(intervalId);
  }

  const scroll_class = ['scroll'];
  isHidden && scroll_class.push('hidden');

  return (
      <div id='scroll_button'> 
        <div className={scroll_class.join(' ')} onClick={() => scrollToTop()}></div>
    </div>      
  );   
} 
